import _                          from 'underscore';
import React, { FC, ReactNode }   from 'react';
import { Label, LabelGroupProps } from 'semantic-ui-react';
import { Tag, TagProps }          from './Tag';

import { CorvalActivityTag, CorvalTag } from '../../../types';
import { runIfFunction }                from '../../../util';

export interface TagCloudProps extends Omit<TagProps, 'content' | 'onClick' | 'onRemove'> {
	tags: any[],
	size?: LabelGroupProps['size'],
	emptyComponent?: ReactNode,
	
	onClick?( index, content ): void,
	
	onRemove?( index, content ): void,
}

const defaultProps: TagCloudProps = {
	tags:           [],
	size:           null,
	emptyComponent: null,
	onClick:        null,
	onRemove:       null,
}

const TagCloud: FC<TagCloudProps> = ( props ) => {
	
	let { tags, size, emptyComponent, onClick, onRemove, ...tagProps } = props;
	
	let hasTags = !_.chain( tags ).compact().isEmpty().value();
	
	// No valid tags to show
	if( !hasTags ){
		
		return <>{ emptyComponent }</> ?? null;
	}
	
	const handleTagClicked = ( index, content ) => {
		
		runIfFunction( onClick, index, content )
	}
	
	const handleTagRemoved = ( index, content ) => {
		
		runIfFunction( onRemove, index, content )
	}
	
	return (
		
		<Label.Group size={ size }>
			
			{ tags.map( ( tag, index ) => {
				
				// Sstring
				let label = tag;
				
				// CorvalTag
				if( _.has( tag, 'name' ) ){
					label = ( tag as CorvalTag ).name
				}
				
				// CorvalActivityTag
				if( _.has( tag, 'tagName' ) ){
					label = ( tag as CorvalActivityTag ).tagName
				}
				
				return (
					<Tag key={ index }
					     onClick={ _.isFunction( onClick ) ? () => handleTagClicked( index, label ) : null }
					     onRemove={ _.isFunction( onRemove ) ? () => handleTagRemoved( index, label ) : null }
					     content={ label }
					     { ...tagProps }
					/>
				)
				
			} ) }
		</Label.Group>
	);
};

TagCloud.defaultProps = defaultProps;

export { TagCloud }
